import { Parcella } from './parcella';

export class ParcellaStragiudiziale extends Parcella {

}
